module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-select",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "z-select-container"
  }, [(_vm.$props.label) ? _c('label', {
    attrs: {
      "for": _vm.$props.id
    },
    domProps: {
      "innerHTML": _vm._s((_vm.$props.label + ((_vm.$props.required) ? '<span>*</span>' : '') + (_vm.$props.readonly ? ' (только для чтения)' : '') + (_vm.$props.loading ? ' (загрузка)' : '')))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "z-select__input-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    attrs: {
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.val = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.change]
    }
  }, [_vm._t("default")], 2), _c('i', {
    staticClass: "z-select__arrow"
  }, [_c('svg', {
    attrs: {
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])])])]), (_vm.error) ? _c('span', {
    staticClass: "z-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93c89278","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZSelect.vue
// module id = 1218
// module chunks = 0